export default "__VITE_ASSET__BiNopfde__"